// Defines filters display order and labels in UI

const filtersDisplayConfig = [
  // TODO: to think about if this is the most adequate place to put additional filters that are not shown in the UI
  {
    "name": "FILTER_IMPLEMENTATION_KEY",
    selectedOptions: ["liveStream"],
    hidden: true
  },
  {
    "name": "FILTER_CREATED",
    "label": "Date Created",
    isSeparatedAbove: true,
    "type": "collapsibleSelect",
    options: [
      {
          "name": "All",
          "data": "All"
      },
      {
          "name": "Past 24 Hours",
          "data": "Past24Hours"
      },
      {
          "name": "Past Week",
          "data": "PastWeek"
      },
      {
          "name": "Past Month",
          "data": "PastMonth"
      },
      {
          "name": "Past Year",
          "data": "PastYear"
      }
    ],
    selectedOptions: ["All"]
  },
  {
    "name": "FILTER_MODIFIED",
    "label": "Date Modified",
    "type": "collapsibleSelect",
    options: [
      {
          "name": "All",
          "data": "All"
      },
      {
          "name": "Past 24 Hours",
          "data": "Past24Hours"
      },
      {
          "name": "Past Week",
          "data": "PastWeek"
      },
      {
          "name": "Past Month",
          "data": "PastMonth"
      },
      {
          "name": "Past Year",
          "data": "PastYear"
      }
    ],
    selectedOptions: ["All"]
  }
]

export default filtersDisplayConfig;